export default class HomeController {

    activate() {
        this.minNbOfRecipes = 10;
    }
}
